import React from 'react';
import {connect} from 'react-redux';
import PropTypes from 'prop-types';

import Icon               from 'app/components/common/icon';
import Link               from 'app/components/common/link';
import Meta               from 'app/components/common/meta';
import AppChecklist       from 'app/components/company-admin/grant-system/app-checklist';
import AppTimeline        from 'app/components/company-admin/grant-system/app-timeline';
import ModalReassign      from 'app/components/company-admin/grant-system/modal-reassign';
import CadminLayout       from 'app/components/company-admin/layout/';
import AppProfile         from 'app/components/grant-system/app-profile';
import PageLoading        from 'app/components/layout/page-loading';
import GrantSysDuck       from 'app/ducks/company-admin/grant-system';
import helpers            from 'app/helpers/grant-system';
import paths              from 'app/paths';
import CadminSlx          from 'app/selectors/company-admin/';
import RoutingSlx         from 'app/selectors/routing';



const {
  AppStatuses,
} = helpers;

class CadminPageApp extends React.PureComponent {

  constructor(props) {
    super(props);

    this.state = {
      showReassignModal: false,
    };

    this.onClickReassign = this.onClickReassign.bind(this);
    this.onCloseReassign = this.onCloseReassign.bind(this);
  }

  componentDidMount() {
    window.app = this.props.app;
  }

  get currentTab() {
    if (!['timeline', 'assignees', 'application'].includes(this.props.currentTab)) return 'assignees';
    return this.props.currentTab;
  }

  get stage() {
    const {workflow, app} = this.props;
    if (!app || !workflow) return null;
    return workflow.stages.find(stage => stage.id === app.currentGrantStageId) || null;
  }

  get canReassign() {
    return this.props.app?.status === AppStatuses.REVIEW;
  }

  onClickReassign() {
    this.setState({showReassignModal: true});
  }
  onCloseReassign() {
    this.setState({showReassignModal: false});
  }

  renderTabTimeline() {
    if (this.currentTab !== 'timeline') return null;

    return (
      <div className="capg-gapp-timeline">
        <AppTimeline />
      </div>
    );
  }
  renderTabAssignees() {
    const {company, app, program, workflow, assignments} = this.props;
    if (this.currentTab !== 'assignees') return null;

    return (
      <div>
        <AppChecklist company={company} app={app} workflow={workflow} assignments={assignments} />
      </div>
    );
  }
  renderTabApplication() {
    const {company, app, program, workflow, assignments, commentMap} = this.props;
    if (this.currentTab !== 'application') return null;

    return (
      <div>
        <AppProfile app={app} program={program} center={false} commentMap={commentMap} />
      </div>
    );
  }

  render() {
    const {company, app, program, workflow, assignments} = this.props;
    const {showReassignModal} = this.state;
    if (!company) return <PageLoading />;
    const title = app?.number ? `Grant Application #${app.number}` : 'Grant Application';
    const activeClass = (tab) => ((tab === this.currentTab) ? 'active' : '');

    return (
      <CadminLayout company={company} activeItem="grant-programs" className="capg-gapp">
        <Meta title={`${title} | Millie`} />

        <div className="ca-main-head">
          <Link className="ca-main-head-back" href={program ? paths.cadminGrantProgram(company.slug, program.id) : '#'}><Icon.Caret direction="left" /> {program?.title || 'Back'}</Link>
          <h1 className="ca-main-head-h1">{title}</h1>
          {!!this.stage && (
            <div className="capg-gapp-stage-chip" style={{backgroundColor: this.stage.color}}>{this.stage.title}</div>
          )}
          <div className="ca-main-head-actions">
            {this.canReassign && (
              <button onClick={this.onClickReassign} className="btn secondary small">Reassign</button>
            )}
          </div>
        </div>

        <div className="ca-main-tabs">
          <Link href={paths.cadminGrantApp(company.slug, app?.id, 'timeline')}    className={`ca-main-tabs-tab ${activeClass('timeline')}`}>Timeline</Link>
          <Link href={paths.cadminGrantApp(company.slug, app?.id, 'assignees')}   className={`ca-main-tabs-tab ${activeClass('assignees')}`}>Assignees</Link>
          <Link href={paths.cadminGrantApp(company.slug, app?.id, 'application')} className={`ca-main-tabs-tab ${activeClass('application')}`}>Application</Link>
        </div>

        {this.renderTabTimeline()}
        {this.renderTabAssignees()}
        {this.renderTabApplication()}
        {showReassignModal && (
          <ModalReassign onClose={this.onCloseReassign} app={app} />
        )}
      </CadminLayout>
    );
  }

}

const stateToProps = (state) => {
  const app = GrantSysDuck.Slx.pathApp(state);
  return {
    company: CadminSlx.company(state),
    app,
    program: GrantSysDuck.Slx.appProgram(state, app),
    assignments: GrantSysDuck.Slx.appAssignments(state, app),
    workflow: GrantSysDuck.Slx.appWorkflow(state, app),
    commentMap: GrantSysDuck.Slx.appCommentMap(state, app),
    currentTab: RoutingSlx.params(state).tab,
  };
};
const dispatchToProps = (dispatch) => ({});

export default connect(stateToProps, dispatchToProps)(CadminPageApp);
